module.exports = __webpack_public_path__ + "img/libra-3.05873793.png";